export default "__VITE_ASSET__CRu9dnuN__"